module.exports = __webpack_public_path__ + "static/media/10-30.2f10a54d.svg";